import {
  Step,
  StepIconProps,
  StepLabel,
  Stepper as MuiStepper,
} from '@material-ui/core'
import clsx from 'clsx'

import { useStyles } from './styles'

interface StepperProps {
  activeStep: number
  steps: string[]
}

const StepIcon = ({ active, completed }: StepIconProps) => {
  const classes = useStyles()

  return (
    <div
      className={clsx(classes.stepIcon, {
        [classes.activeStepIcon]: active || completed,
      })}
    />
  )
}

export const Stepper = ({ activeStep, steps }: StepperProps) => {
  const classes = useStyles()

  return (
    <MuiStepper activeStep={activeStep} className={classes.root}>
      {steps.map((label) => (
        <Step key={label}>
          <StepLabel
            StepIconComponent={StepIcon}
            classes={{
              root: classes.labelStepRoot,
            }}
          >
            {label}
          </StepLabel>
        </Step>
      ))}
    </MuiStepper>
  )
}
